import styled from 'styled-components';

export const HeaderCanelMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        box-shadow: 0 -1px 4px 1px rgba(74, 74, 74, 0.2);
    `
);

export const HeaderCancelOuterWrap = styled.div(
    props => `
        display: flex;
        width:100%;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l30};
    `
)

export const HeaderCancelImgWrap = styled.div(
    props => `
        width:6rem;
        height:6rem;
        margin-right: ${props.theme.spacing.large.l15}
    `
);

export const HeaderCancelInfoWrap = styled.div(
    props => `
        width:90%;
        display: flex;
        flex-direction: column;
    `
);

export const HeaderCancelText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font22};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const HeaderCancelInfoInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    `
);

export const HeaderCancelHtlInfo = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
    `
);

export const HeaderCancelHtlDateInfoWrap = styled.div(
    props => `
        display: flex;
        align-self: flex-end;
        align-items: center;
        justify-content:center;
    `
);

export const HeaderCacnelHtlDateImg = styled.div(
    props => `
        width:2.4rem;
        height: 2.4rem;
        margin-right:  ${props.theme.spacing.base};
    `
);

export const HeaderCancelDateText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
    `
);
